/* TSF · upsell del carrito: ofertas primero, después los más vendidos, sin repetir lo que ya está en el carrito. */
(function () {
  if (customElements.get('tsf-upsell')) return;

  const CACHE_KEY = 'tsfu-feed-v4';
  const CACHE_MS = 10 * 60 * 1000;
  let feedPromise = null;

  function getFeed(url) {
    if (feedPromise) return feedPromise;
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (cached && Date.now() - cached.t < CACHE_MS) {
        feedPromise = Promise.resolve(cached.d);
        return feedPromise;
      }
    } catch (e) { /* sin storage */ }
    feedPromise = fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const data = JSON.parse(doc.querySelector('[data-tsfu-feed]').textContent);
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data })); } catch (e) { /* sin storage */ }
        return data;
      })
      .catch(() => { feedPromise = null; return []; });
    return feedPromise;
  }

  // Productos que Shopify relaciona con los del carrito (compras y vistas conjuntas en la tienda)
  async function getRelated(ids) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const lists = await Promise.all(
      ids.map(async (id) => {
        const key = `tsfu-rel-${id}`;
        try {
          const cached = JSON.parse(sessionStorage.getItem(key));
          if (cached && Date.now() - cached.t < CACHE_MS) return cached.d;
        } catch (e) { /* sin storage */ }
        try {
          const r = await fetch(`${root}recommendations/products.json?product_id=${id}&limit=6&intent=related`).then((x) => x.json());
          const d = (r.products || []).map((p) => p.id);
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d })); } catch (e) { /* sin storage */ }
          return d;
        } catch (e) {
          return [];
        }
      })
    );
    // intercalados: el primero de cada producto del carrito, después el segundo…
    const out = [];
    for (let i = 0; i < 6; i++) lists.forEach((l) => { if (l[i] != null && !out.includes(l[i])) out.push(l[i]); });
    return out;
  }

  function formatMoney(cents, format) {
    if (window.tsfpFormatMoney) return window.tsfpFormatMoney(cents, format);
    const fmt = format || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const m = fmt.match(re);
    const dec = m && m[1].includes('no_decimals') ? 0 : 2;
    const comma = m && m[1].includes('comma');
    let [a, b] = (cents / 100).toFixed(dec).split('.');
    a = a.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    return fmt.replace(re, a + (b ? (comma ? ',' : '.') + b : ''));
  }

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class TsfUpsell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.track = this.querySelector('.tsfu__track');
      this.fmt = this.dataset.moneyFormat;
      this.build();
      this.addEventListener('click', (e) => {
        const add = e.target.closest('.tsfu__add');
        if (add) this.add(add);
        const optBtn = e.target.closest('.tsfu__opt-btn');
        if (optBtn) {
          const list = optBtn.nextElementSibling;
          const open = list.hidden;
          this.querySelectorAll('.tsfu__opt-list').forEach((l) => { l.hidden = true; l.previousElementSibling.setAttribute('aria-expanded', 'false'); l.closest('.tsfu__card').classList.remove('is-open'); });
          list.hidden = !open;
          optBtn.setAttribute('aria-expanded', String(open));
          optBtn.closest('.tsfu__card').classList.toggle('is-open', open);
        }
        const item = e.target.closest('.tsfu__opt-item');
        if (item) {
          const card = item.closest('.tsfu__card');
          card.querySelectorAll('.tsfu__opt-item').forEach((o) => { o.classList.toggle('is-on', o === item); o.setAttribute('aria-selected', String(o === item)); });
          card.querySelector('.tsfu__opt-cur').textContent = item.querySelector('span').textContent;
          card.querySelector('.tsfu__opt-list').hidden = true;
          card.querySelector('.tsfu__opt-btn').setAttribute('aria-expanded', 'false');
          card.classList.remove('is-open');
          this.paintCard(card, +item.dataset.v);
        }
      });
    }

    async build() {
      const data = await getFeed(this.dataset.feed);
      const inCartIds = (this.dataset.inCart || '').split(',').filter(Boolean).map(Number);
      const inCart = new Set(inCartIds);
      const max = +this.dataset.max || 8;
      const byId = new Map(data.map((p) => [p.id, p]));
      const off = (p) =>
        p.variants.reduce((best, v) => (v.available && v.compare > v.price ? Math.max(best, Math.round((1 - v.price / v.compare) * 100)) : best), 0);

      // 1) Lo que Shopify relaciona con lo del carrito (intent=related mezcla compras, similitud y colecciones: no son compras conjuntas seguras, por eso "Pairs well")
      const recIds = await getRelated(inCartIds.slice(-3).reverse());
      // 2) Espesores de lo que ya está en el carrito
      const cartWeights = new Map();
      inCartIds.forEach((id) => (byId.get(id)?.weights || []).forEach((w) => cartWeights.set(w.h, w.t)));

      const usable = (p) => p && p.available && !inCart.has(p.id);
      const picks = [];
      const seen = new Set();
      const push = (p, reason) => {
        if (!usable(p) || seen.has(p.id) || picks.length >= max) return;
        seen.add(p.id);
        picks.push({ ...p, off: off(p), reason });
      };
      recIds.slice(0, 3).forEach((id) => push(byId.get(id), 'Pairs well'));
      const sameWeight = (p) => (p.weights || []).filter((w) => cartWeights.has(w.h));
      data
        .filter((p) => sameWeight(p).length && usable(p))
        .sort((a, b) => off(b) - off(a) || a.rank - b.rank)
        .slice(0, 3)
        .forEach((p) => push(p, `Same thickness · ${sameWeight(p).map((w) => w.t).join(', ')}`));
      recIds.slice(3).forEach((id) => push(byId.get(id), 'Pairs well'));
      data.filter((p) => off(p) > 0).sort((a, b) => off(b) - off(a)).forEach((p) => push(p, 'On sale'));
      data.slice().sort((a, b) => a.rank - b.rank).forEach((p) => push(p, p.rank <= 5 ? 'Best seller' : ''));

      if (!picks.length) {
        this.hidden = true;
        return;
      }
      this.products = new Map(picks.map((p) => [String(p.id), p]));
      const show = +this.dataset.show || 4;
      this.track.innerHTML = picks.map((p, i) => this.card(p, i >= show)).join('');
      const more = this.querySelector('.tsfu__more');
      if (more) {
        const hiddenCount = Math.max(0, picks.length - show);
        more.hidden = hiddenCount === 0;
        more.textContent = `Show ${hiddenCount} more`;
        more.onclick = () => {
          this.track.querySelectorAll('.tsfu__card[hidden]').forEach((c) => (c.hidden = false));
          more.hidden = true;
        };
      }
      this.hidden = false;
    }

    card(p, hide) {
      const variants = p.variants.filter((v) => v.available);
      // Si hay variantes en oferta, arranca en la de mayor descuento
      const first = variants.slice().sort((a, b) => (b.compare > b.price ? 1 - b.price / b.compare : 0) - (a.compare > a.price ? 1 - a.price / a.compare : 0))[0] || variants[0];
      const badge = p.off > 0
        ? `<span class="tsfu__badge tsfu__badge--sale">-${p.off}%</span>`
        : '';
      const select = variants.length > 1
        ? `<div class="tsfu__opt">
            <button type="button" class="tsfu__opt-btn" aria-expanded="false"><span class="tsfu__opt-cur">${esc(first.title)}</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>
            <ul class="tsfu__opt-list" role="listbox" hidden>${variants
              .map((v) => `<li><button type="button" role="option" class="tsfu__opt-item${v.id === first.id ? ' is-on' : ''}" data-v="${v.id}" aria-selected="${v.id === first.id}"><span>${esc(v.title)}</span><span class="tsfu__opt-price">${formatMoney(v.price, this.fmt)}</span></button></li>`)
              .join('')}</ul>
          </div>`
        : '';
      return `<li class="tsfu__card" data-product="${p.id}" data-variant="${first.id}"${hide ? ' hidden' : ''}>
        <a class="tsfu__img" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">
          ${(first.img || p.img) ? `<img src="${esc(first.img || p.img)}" alt="" loading="lazy" width="120" height="120">` : ''}${badge}
        </a>
        <div class="tsfu__info">
          <a class="tsfu__name" href="${esc(p.url)}">${esc(p.title)}</a>
          ${p.reason ? `<span class="tsfu__reason${p.reason.startsWith('Pairs') ? ' tsfu__reason--rec' : ''}">${esc(p.reason)}</span>` : ''}
          <p class="tsfu__price${first.compare > first.price ? ' is-sale' : ''}"><span>${formatMoney(first.price, this.fmt)}</span>${first.compare > first.price ? `<s>${formatMoney(first.compare, this.fmt)}</s>` : ''}</p>
          ${select}
        </div>
        <button type="button" class="tsfu__add" aria-label="Add ${esc(p.title)} to cart">
          <svg class="tsfu__plus" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
          <svg class="tsfu__check" viewBox="0 0 24 24" aria-hidden="true"><path d="m5.5 12.5 4 4 9-9"/></svg>
          <span class="visually-hidden">Add</span>
        </button>
      </li>`;
    }

    paintCard(card, id) {
      const p = this.products.get(card.dataset.product);
      const v = p.variants.find((x) => x.id === id);
      if (!v) return;
      card.dataset.variant = v.id;
      const img = card.querySelector('.tsfu__img img');
      if (img && v.img && img.getAttribute('src') !== v.img) {
        img.classList.add('is-swapping');
        const pre = new Image();
        pre.onload = () => { img.src = v.img; img.classList.remove('is-swapping'); };
        pre.onerror = () => img.classList.remove('is-swapping');
        pre.src = v.img;
      }
      const price = card.querySelector('.tsfu__price');
      const sale = v.compare > v.price;
      price.classList.toggle('is-sale', sale);
      price.innerHTML = `<span>${formatMoney(v.price, this.fmt)}</span>${sale ? `<s>${formatMoney(v.compare, this.fmt)}</s>` : ''}`;
    }

    async add(btn) {
      const card = btn.closest('.tsfu__card');
      const label = btn.querySelector('span');
      const drawer = document.querySelector('cart-drawer');
      const useDrawer = this.dataset.context !== 'page' && drawer && typeof drawer.renderContents === 'function';
      const body = { id: +card.dataset.variant, quantity: 1 };
      if (useDrawer) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        }).then((r) => r.json());
        btn.classList.remove('is-loading');
        if (res.status) {
          btn.disabled = false;
          card.classList.add('is-error');
          label.textContent = res.description || 'Unavailable';
          return;
        }
        btn.classList.add('is-added');
        label.textContent = 'Added';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tsf-upsell', productVariantId: body.id, cartData: res });
        }
        if (useDrawer) {
          // igual que el botón de la ficha: si el cajón estaba vacío, se le saca el estado "vacío" antes de redibujarlo
          setTimeout(() => {
            drawer.classList.remove('is-empty');
            drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
            drawer.renderContents(res);
          }, 550);
        } else {
          setTimeout(() => window.location.reload(), 550);
        }
      } catch (e) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }
  }

  customElements.define('tsf-upsell', TsfUpsell);

  // Botón "+N" del empujón por cantidad: pone la cantidad del escalón y deja que Dawn actualice el carrito
  document.addEventListener('click', (e) => {
    const box = e.target.closest('.tsfu-nudge:not(.tsfu-nudge--done)');
    const btn = e.target.closest('[data-tsfu-set-qty]') || box?.querySelector('[data-tsfu-set-qty]');
    if (!btn) return;
    box?.classList.add('is-busy');
    const input = document.getElementById(`Drawer-quantity-${btn.dataset.index}`) || document.getElementById(`Quantity-${btn.dataset.index}`);
    if (!input) return;
    btn.disabled = true;
    // se deja una unidad por debajo y se aprieta el "+" de Dawn, que es quien dispara la actualización del carrito
    const plus = input.closest('quantity-input')?.querySelector('.quantity__button[name="plus"]');
    if (plus) {
      input.value = Math.max(0, +btn.dataset.tsfuSetQty - 1);
      plus.click();
    } else {
      input.value = btn.dataset.tsfuSetQty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
